<template>
  <el-main>
    <div  class="passengers--onboarding">
      <p v-if="trip.route"> Onboarding Passenger for <strong> {{trip.route.description}} </strong> </p>
      <div>
        <el-date-picker
          type="date"
          placeholder="Query passenger by Departure Date"
          v-model="tripDate"/>
      </div>
      <div v-if="passengers.length > 0">
        <el-checkbox-group v-model="selectedPassengers" size="small" class="passengers">
          <div v-for="(passenger, index) in passengers" :key="index" class="passenger">
            <el-checkbox :label="passenger.id" border>
              <div class="passenger--info">
                <span class=""> <strong>{{ passenger.ref }} </strong> </span>
                <span class=""> {{ passenger.full_name }} </span>
                <span> {{ passenger.gender }} </span>
                <span> Seat Nos [{{ passenger.seat_nos }}] </span>
                <span> +234 {{ passenger.tel_no }} </span>
                <span> Adults <b>({{ passenger.others.length }}) </b></span>
              </div>
            </el-checkbox>
          </div>
        </el-checkbox-group>
        <el-button type="primary" style="width:100%" @click="handleFinishRegistration"> Finish Registration </el-button>
      </div>
      <div v-else>
        <h1 class="text-center"> NO PASSENGERS FOUND FOR THIS ROUTE DURING THIS DEPARTURE TIME  </h1>
      </div>
    </div>
  </el-main>
</template>

<script>
import { getPassengers } from '@/services/passenger'
import { getTrip, registerPassengers } from '@/services/trip'
import { format } from 'date-fns'

export default {
  name: 'RegisterPassenger',
  data () {
    return {
      passengers: [],
      selectedPassengers: [],
      tripDate: Date.now(),
      trip: {}
    }
  },
  mounted () {
    const id = this.$route.params.id
    if (id) {
      this.findTrip(id)
    }
  },

  methods: {
    findTrip (id) {
      getTrip(id)
        .then(res => {
          this.trip = res.data
          this.loadOnlyTodaysPassengers()
          if (this.trip.passengers) {
            this.trip.passengers.map(p => {
              this.selectedPassengers.push(p)
            })
          }
        })
    },

    handleFinishRegistration () {
      const data = {
        trip: this.trip.id,
        passengers: this.selectedPassengers
      }
      registerPassengers(this.trip.id, data)
        .then(res => {
          this.$message(res.data.message)
          setTimeout(this.gotoTripPage, 1000)
        })
    },

    gotoTripPage () {
      this.$router.push({ name: 'Trips' })
    },

    loadOnlyTodaysPassengers () {
      const now = format(Date.now(), 'YYYY-MM-DD')
      // query only passengers that are going today for this
      // particular trip route
      getPassengers(`dep_date=${now}&route=${this.trip.route.id}`)
        .then(res => {
          this.passengers = res.data
        })
        .catch(() => {
          this.$message.error('Could not load passenger for this Route or Date')
        })
    }
  }
}
</script>
<style lang="scss" scoped>

.passenger--info {
  display: flex;
  & span {
    margin: 10px;
  }
}

.passengers--onboarding {
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 70%;
  margin: auto;

  & .passenger {

    display: flex;
    min-width: 100%;
    margin-bottom: 10px;

    & label {
      display: flex;
      height: 50px;
      flex-grow: 1;
      align-items: center;
      background: #fff;
      font-weight: bold;

      & span.el-checkbox__input {
        display: none;
      }
      & span.el-checkbox__label {
        display: flex;
        justify-content: center;
      }
    }
  }
}

@media screen and (max-width: 600px) {
  .passengers--onboarding {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/trips/RegisterPassenger.vue